var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-select"},[_c('label',{staticClass:"app-select__label"},[_vm._v(_vm._s(_vm.getTranslatedText('Select the event')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }